import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { Button } from 'src/presentation/components/agent_desktop_components';
import PopoverMenu, { usePopoverMenu } from '@ad-scripts/presentation/components/common/menu';
import { StyledMenuItem } from '@ad-scripts/presentation/components/common/dropdown_menu';

export enum HelpButtonPosition {
  BOTTOM_LEFT,
  BOTTOM_RIGHT,
}

type HelpButtonProps = {
  position: HelpButtonPosition;
};

const HelpButton: FC<HelpButtonProps> = ({ position }) => {
  const { targetRef, setTargetRef, isOpen, onClose, onToggle } = usePopoverMenu();

  return (
    <>
      <StyledButton type={Button.Types.SECONDARY} onClick={onToggle} ref={setTargetRef} position={position}>
        Help
      </StyledButton>

      <PopoverMenu
        data-aid="helpMenu"
        isOpen={isOpen}
        onClose={onClose}
        position="top"
        targetPosition={position === HelpButtonPosition.BOTTOM_LEFT ? 'start' : 'end'}
        targetRef={targetRef}
      >
        <MenuItemsContainer>
          <StyledMenuItem>
            <ExternalLink href="https://help.gladly.com/docs/view-your-ivr-configurations/">Help Docs</ExternalLink>
          </StyledMenuItem>
          <StyledMenuItem>
            <ExternalLink href="https://www.research.net/r/6Y6PKGZ">Feedback</ExternalLink>
          </StyledMenuItem>
        </MenuItemsContainer>
      </PopoverMenu>
    </>
  );
};

const MenuItemsContainer = styled.div`
  padding 12px 0;
`;

const StyledButton = styled(Button)`
  bottom: 24px;
  position: fixed;
  ${p => (p.position === HelpButtonPosition.BOTTOM_LEFT ? 'left' : 'right')}: 24px;
`;

const linkStyle = css`
  color: ${p => p.theme.colors.black};
  text-decoration: none;
`;

const ExternalLink = styled.a`
  ${linkStyle};
`;

export default HelpButton;
